// Generated by BUCKLESCRIPT VERSION 1.9.3, PLEASE EDIT WITH CARE
'use strict';

var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/reasonReact.js");

var component = ReasonReact.statelessComponent("Slide");

function make(attributes, active, children) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var transform = "translate(-50%,-50%) translate3d(" + (Pervasives.string_of_int(attributes[/* translate */0][/* x */0]) + ("px," + (Pervasives.string_of_int(attributes[/* translate */0][/* y */1]) + ("px," + (Pervasives.string_of_int(attributes[/* translate */0][/* z */2]) + ("px) rotateX(" + (Pervasives.string_of_int(attributes[/* rotate */1][/* x */0]) + ("deg) rotateY(" + (Pervasives.string_of_int(attributes[/* rotate */1][/* y */1]) + ("deg) rotateZ(" + (Pervasives.string_of_int(attributes[/* rotate */1][/* z */2]) + ("deg) scale(" + (Pervasives.string_of_float(attributes[/* scale */2]) + "0)")))))))))))));
      return ReasonReact.createDomElement("div", {
                  className: "slide " + (
                    active !== 0 ? "active" : ""
                  ),
                  style: {
                    position: "absolute",
                    opacity: active !== 0 ? "1" : "0",
                    transform: transform,
                    transformStyle: "preserve-3d"
                  }
                }, children);
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/slide.re
// module id = 22
// module chunks = 0